import { render, staticRenderFns } from "./DefectGroupBodyworkV1Input.vue?vue&type=template&id=22438c2d&scoped=true"
import script from "./DefectGroupBodyworkV1Input.vue?vue&type=script&lang=ts&setup=true"
export * from "./DefectGroupBodyworkV1Input.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./DefectGroupBodyworkV1Input.vue?vue&type=style&index=0&id=22438c2d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22438c2d",
  null
  
)

export default component.exports